import { forwardRef, useState, useCallback } from "react";
import { motion } from "framer-motion";
import { springs } from "../motion";
import type { TextareaProps } from "./types";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className = "", onFocus, onBlur, ...rest }, ref) {
    const [focused, setFocused] = useState(false);

    const handleFocus = useCallback(
      (e: React.FocusEvent<HTMLTextAreaElement>) => {
        setFocused(true);
        onFocus?.(e);
      },
      [onFocus],
    );

    const handleBlur = useCallback(
      (e: React.FocusEvent<HTMLTextAreaElement>) => {
        setFocused(false);
        onBlur?.(e);
      },
      [onBlur],
    );

    return (
      <motion.div
        className={`rounded-lg border bg-card ${className}`}
        animate={{
          borderColor: focused ? "var(--color-accent)" : "var(--color-border)",
          boxShadow: focused
            ? "0 0 0 3px var(--color-accent-soft)"
            : "0 0 0 0px transparent",
        }}
        transition={springs.snappy}
      >
        <textarea
          ref={ref}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className="w-full bg-transparent px-3 py-2 text-[13px] text-primary placeholder:text-muted outline-none resize-none"
          {...rest}
        />
      </motion.div>
    );
  },
);
